import React from "react";
import { Router } from "./router";

export const App = () => <Router />;
